import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=37df8e32&scoped=true&"
import script from "./ScrollPane.vue?vue&type=script&lang=js&"
export * from "./ScrollPane.vue?vue&type=script&lang=js&"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&id=37df8e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37df8e32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37df8e32')) {
      api.createRecord('37df8e32', component.options)
    } else {
      api.reload('37df8e32', component.options)
    }
    module.hot.accept("./ScrollPane.vue?vue&type=template&id=37df8e32&scoped=true&", function () {
      api.rerender('37df8e32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/components/TagsView/ScrollPane.vue"
export default component.exports